import FouSelect from 'components/form/fou-select'
import FouSelectTags from 'components/form/fou-select-tags'
import { FouSelectObject } from 'src/utils/objects/fou-select'
import Methods from './designers.methods'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import { TimeoutUtil } from 'src/utils/helper/timer'
import { mapGetters } from 'vuex'
import VSelect from 'src/components/form/v-select/index.vue'
import { useForm } from 'vee-validate'
import { SubmissionObject } from 'src/pages/submissions/script/common.data'
import { isEmpty } from 'lodash'

export default {
  name: 'designers',

  data() {
    return {
      designers: FouSelectObject(),
      inputDelay: TimeoutUtil(),
      hideDrop: true,
      ...SubmissionObject,
      searchingDesigners: false,
      ready: {
        name: this.$options.name,
        state: 'unset'
      }
    }
  },

  setup() {
    const { setFieldValue, errors, validate } = useForm()
    return {
      errors,
      validate,
      setFieldValue
    }
  },

  watch: {
    'designers.values': {
      handler(newVal) {
        this.setFieldValue('designers upload', newVal)
        this.validate()
      },
      deep: true
    },
    errors: {
      handler(newVal) {
        this.updateSubmissionErrors(newVal, 'designers upload')
      },
      immediate: true
    }
  },

  components: {
    FouSelect,
    FouSelectTags,
    VSelect
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('designers', {
      designersList: ['list'],
      designersMinLength: ['minLength'],
      designersExcludeChar: ['excludeChar']
    })
  },

  methods: {
    ...SubmissionMethods,
    ...Methods,
    onSearchBlur() {
      if (isEmpty(this.designers.values)) {
        this.$refs.fouSelectDesigners._value = []
        this.designers.values = []
      }
      this.validate()
      this.designers.options = []
      this.designerStopSearching()
    },
    optionDeselected(option) {
      this.designers.values = this.designers.values?.filter(v => v.value !== option.value)
      this.$refs.fouSelectDesigners._value = this.$refs.fouSelectDesigners._value?.filter(v => v.value !== option.value)

      this.updateDesignersValues(this.designers.values)
      this.validate()
    },
    validateDesigners() {
      this.updateDesignersValues(this.designers.values)
    }
  },

  created() {
    this.addReadyState()
    this.setSubmissionBuild({
      before: this.buildSubmission
    })
    this.setDesigners()
    this.$events?.$on('trigger:validate', () => {
      this.validate()
    })
  },
  beforeUnmount() {
    this.$events?.$off('trigger:validate')
  }
}
